import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import CompanyLegalLine from '../../../components/common/CompanyLegalLine'
import { LEGAL_LINKS } from '../../../config/brand'

/**
 * Shared chrome for the public legal pages (/privacy, /terms, /refund-policy,
 * /pricing, /contact): top bar, page body, and the company footer.
 * English only, light theme — these pages are crawled by Google's OAuth
 * verifier and reviewed by Stripe.
 */
export default function LegalLayout({ title, description, wide = false, children }) {
  useEffect(() => {
    document.title = `${title} — OVACS`
    const meta = document.querySelector('meta[name="description"]') || (() => {
      const m = document.createElement('meta')
      m.name = 'description'
      document.head.appendChild(m)
      return m
    })()
    const previous = meta.content
    if (description) meta.content = description
    return () => {
      document.title = 'OVACS'
      meta.content = previous
    }
  }, [title, description])

  const width = wide ? 'max-w-5xl' : 'max-w-4xl'

  return (
    <div className="min-h-screen bg-white flex flex-col" dir="ltr">
      <header className="border-b border-gray-200 bg-white">
        <div className={`${width} mx-auto px-4 py-4 flex flex-wrap items-center justify-between gap-3`}>
          <Link to="/landing" className="font-semibold text-cyan-600">OVACS</Link>
          <nav className="text-sm text-gray-600 flex flex-wrap items-center gap-x-5 gap-y-1">
            <Link to="/landing" className="hover:text-cyan-700">Home</Link>
            {LEGAL_LINKS.map((l) => (
              <Link key={l.href} to={l.href} className="hover:text-cyan-700">{l.en}</Link>
            ))}
          </nav>
        </div>
      </header>

      <main className={`${width} w-full mx-auto px-4 py-12 flex-1`}>
        {children}
      </main>

      <footer className="border-t border-gray-200 bg-gray-50">
        <div className={`${width} mx-auto px-4 py-6 text-sm flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4`}>
          <CompanyLegalLine />
          <nav className="flex flex-wrap items-center gap-x-4 gap-y-1 text-gray-500">
            {LEGAL_LINKS.map((l) => (
              <Link key={l.href} to={l.href} className="hover:text-cyan-700">{l.en}</Link>
            ))}
          </nav>
        </div>
      </footer>
    </div>
  )
}
